document.addEventListener("DOMContentLoaded", function () {
  // Function to determine if a color is dark
  function isDarkColor(color) {
    // Remove any leading '#' and convert to RGB
    const hex = color.replace("#", "");
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Calculate brightness (YIQ formula)
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness < 128; // Dark if brightness is less than 128
  }

  // Select all color swatches
  const colorSwatches = document.querySelectorAll(
    'input[type="radio"][data-color]'
  );

  colorSwatches.forEach((swatch) => {
    const color = swatch.getAttribute("data-color");
    if (isDarkColor(color)) {
      swatch.style.border = "1px solid #FFFFFF"; // White border for dark colors
    } else {
      swatch.style.border = "1px solid #D9D9D9"; // Light gray border for light colors
    }
  });
  // Select all swatch links
  const swatchLinks = document.querySelectorAll(".swatch-link");

  swatchLinks.forEach((link) => {
    const input = link.querySelector(
      'input[type="radio"][name$="_card_color"]'
    );

    // Add click event listener to the input
    if (input) {
      input.addEventListener("click", (event) => {
        // Prevent the default behavior of the input
        event.preventDefault();

        // Trigger the click on the parent <a> tag
        link.click();
      });
    }
  });

  // Tooltip for native card color swatches
  const tooltip = document.createElement('div');
  tooltip.style.cssText = [
    'position:fixed',
    'background:var(--color-background-inverse)',
    'color:var(--color-typography-primary)',
    'font-family:var(--primary-font-body-family)',
    'font-size:var(--font-size-s)',
    'line-height:normal',
    'padding:var(--spacing-2xs) var(--spacing-xs)',
    'border-radius:var(--primary-button-border-radius)',
    'border:1px solid #e0e0e0',
    'white-space:nowrap',
    'pointer-events:none',
    'z-index:9999',
    'transition:none',
    'opacity:0',
    'visibility:hidden'
  ].join(';');
  document.body.appendChild(tooltip);
  
  function initSwatchTooltips() {
    document.querySelectorAll('.product_tile_color_holder .swatch-link[data-title]').forEach((link) => {
      if (link.dataset.tooltipBound) return;
      link.dataset.tooltipBound = 'true';
  
      const label = link.getAttribute('data-title');
      if (!label) return;
      const input = link.querySelector('input[type="radio"]');
  
      link.addEventListener('mouseenter', () => {
        if (input) {
          input.style.outline = '1px solid #191919';
          input.style.outlineOffset = '1px';
        }
        tooltip.textContent = label;
        tooltip.style.left = '-9999px';
        tooltip.style.top = '-9999px';
        tooltip.style.visibility = 'visible';
        tooltip.style.opacity = '0';
        const tooltipWidth = tooltip.offsetWidth;
        const rect = link.getBoundingClientRect();
        const rawLeft = rect.left + rect.width / 2 - tooltipWidth / 2;
        const left = Math.max(8, Math.min(rawLeft, window.innerWidth - tooltipWidth - 8));
        tooltip.style.left = left + 'px';
        tooltip.style.top  = (rect.top - 6) + 'px';
        tooltip.style.transform = 'translateY(-100%)';
        tooltip.style.opacity = '1';
      });
  
      link.addEventListener('mouseleave', () => {
        if (input) {
          input.style.outline = '';
          input.style.outlineOffset = '';
        }
        tooltip.style.opacity = '0';
        tooltip.style.visibility = 'hidden';
      });
    });
  }
  
  initSwatchTooltips();
});
